import { Component, Element, Prop, h, EventEmitter, Event } from '@stencil/core';
import { arrow_right } from 'pn-design-assets/pn-assets/icons.js';

/**
 * @deprecated This component will be removed in v8. Please use the `pn-tablist` instead.
 * @see {@link https://portal.postnord.com/web-components/?path=/docs/components-navigation-tablist--docs} Use `pn-tablist` instead.
 */
@Component({
  tag: 'pn-page-nav-dropdown-item',
  styleUrl: 'pn-page-nav-dropdown-item.scss',
})
export class PnPageNavDropdownItem {
  @Element() hostElement: HTMLElement;

  /**
   * The value that will be emitted upon selection, only pass this if the item
   * is a link, if you want a button (for quick actions), omit this prop.
   */
  @Prop() value!: string;
  /** Pass an href to the items if you want to have links that lead outside of your app */
  @Prop() href: string;
  /** Ignore this, it's internal communication with parent. @hide true */
  @Prop() active: boolean = false;

  /** Ignore this, it's internal communication with parent */
  @Event() itemselection: EventEmitter<string>;

  select(e: MouseEvent) {
    if (this.value && !this.href) e.preventDefault();

    this.itemselection.emit(this.value);
  }

  setClassnames() {
    let classes = 'pn-page-nav-dropdown-item ';

    if (this.active) classes += 'pn-page-nav-dropdown-item-active ';

    return classes;
  }

  getType() {
    return this.value ? null : 'button';
  }

  getTagName(): string {
    return this.value ? 'a' : 'button';
  }

  render() {
    const TagName = this.getTagName();

    return (
      <li>
        <TagName
          href={this.href || '#'}
          class={this.setClassnames()}
          type={this.getType()}
          onClick={e => this.select(e)}
          tabindex="-1"
        >
          <slot></slot>
          <pn-icon icon={arrow_right} color="white"></pn-icon>
        </TagName>
        <hr />
      </li>
    );
  }
}
